/**
 *
 * FlashCardDetail
 *
 */

import { mapActions } from 'vuex';

import { QuestionFontSizeMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/QuestionFontSizeMixin';

export default {
  name: 'QuestionFontSize',

  mixins: [QuestionFontSizeMixin],

  methods: {
    ...mapActions({
      updateProfile: 'updateProfile',
    }),

    setQuestionFontSize(size) {
      this.updateProfile({ questionFontSize: size });
    },
  },
};
